<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Files">
    </PageHeader>
    
    <div class="container">
      <!-- Loading -->
      <Loading v-if="loading" class="p-6" />
      <!-- List -->
      <div class="card" v-else>
      <!-- No Results -->
        <div v-if="files.meta.total < 1" class="max-w-sm py-12 mx-auto text-center">
          <div class="mb-2 text-lg font-bold">
            No files have been uploaded yet.
          </div>
          <div class="text-gray-500">
            Any time a file is attached to a record it will be indexed here.
          </div>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table :items="files.data" 
            :keys="[
              { 
                name: 'Name', 
                slug: 'name', 
                class: 'font-bold' 
              },
              { 
                name: 'Upload Date', 
                slug: 'created_at', 
                display: (val) => moment(val).format('DD/MM/YYYY') 
              }
            ]">
            <template #icon>
              <fa :icon="['far', 'file']" class="opacity-50" />
            </template>
            <template #actions="{ item }">
              <button class="btn btn-sm btn-secondary" @click="showFile(item.id)">
                View
              </button>
            </template>
          </data-table>

          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="files.meta.total" :per-page="files.meta.per_page" :current-page="files.meta.current_page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'FileList',

  metaInfo: {
    title: 'Files'
  },

  created () {
    this.getFiles()
  },

  data () {
    return {
      loading: true,
      files: {},
      moment
    }
  },

  methods: {
    async getFiles () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/files`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.files = data.files
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    async showFile (id) {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/files/${id}`)
        window.open(data.url, '_blank')
      } catch (error) {
        console.error(error)
      }
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getFiles()
      },
      deep: true
    }
  }
}
</script>